[
  {
    "info": "A global table that contains all global variables and functions.",
    "label": "_G",
    "type": "variable",
    "detail": "Global environment"
  },
  {
    "info": "A global variable that contains a string describing the current interpreter version.",
    "label": "_VERSION",
    "type": "variable",
    "detail": "Lua version"
  },
  {
    "info": "Raises an error if the value of its argument `v` is false (i.e., nil or false); otherwise, returns all its arguments.",
    "label": "assert",
    "type": "function",
    "detail": "(v [, message])"
  },
  {
    "info": "This function is a generic interface to the garbage collector. It performs different functions according to its first argument, opt.",
    "label": "collectgarbage",
    "type": "function",
    "detail": "([opt [, arg]])"
  },
  {
    "info": "Opens the named file and executes its contents as a Lua chunk.",
    "label": "dofile",
    "type": "function",
    "detail": "([filename])"
  },
  {
    "info": "Terminates the last protected function called and returns message as the error object.",
    "label": "error",
    "type": "function",
    "detail": "(message [, level])"
  },
  {
    "info": "Returns the metatable of the given object or nil if it does not have a metatable.",
    "label": "getmetatable",
    "type": "function",
    "detail": "(object)"
  },
  {
    "info": "Returns three values: an iterator function, the table t, and 0, so that the construction `for i,v in ipairs(t)` will iterate over the pairs (1,t[1]), (2,t[2]), ..., up to the first integer key absent from the table.",
    "label": "ipairs",
    "type": "function",
    "detail": "(t)"
  },
  {
    "info": "Loads a chunk. If chunk is a string, the chunk is this string. If chunk is a function, load calls it repeatedly to get the chunk pieces.",
    "label": "load",
    "type": "function",
    "detail": "(chunk [, chunkname [, mode [, env]]])"
  },
  {
    "info": "Similar to load, but gets the chunk from file filename or from the standard input, if no file name is given.",
    "label": "loadfile",
    "type": "function",
    "detail": "([filename [, mode [, env]]])"
  },
  {
    "info": "Allows a program to traverse all fields of a table. Its first argument is a table and its second argument is an index in this table.",
    "label": "next",
    "type": "function",
    "detail": "(table [, index])"
  },
  {
    "info": "Returns three values: the next function, the table t, and nil, so that the construction `for k,v in pairs(t)` will iterate over all key–value pairs of table t.",
    "label": "pairs",
    "type": "function",
    "detail": "(t)"
  },
  {
    "info": "Calls function f with the given arguments in protected mode. It catches any errors during the call and returns a status code.",
    "label": "pcall",
    "type": "function",
    "detail": "(f [, arg1, ...])"
  },
  {
    "info": "Receives any number of arguments and prints their values to stdout, converting each argument to a string following the same rules of tostring.",
    "label": "print",
    "type": "function",
    "detail": "(...)"
  },
  {
    "info": "Checks whether v1 is equal to v2, without invoking the __eq metamethod.",
    "label": "rawequal",
    "type": "function",
    "detail": "(v1, v2)"
  },
  {
    "info": "Gets the real value of table[index], without invoking the __index metamethod.",
    "label": "rawget",
    "type": "function",
    "detail": "(table, index)"
  },
  {
    "info": "Returns the length of the object v, which must be a table or a string, without invoking the __len metamethod.",
    "label": "rawlen",
    "type": "function",
    "detail": "(v)"
  },
  {
    "info": "Sets the real value of table[index] to value, without invoking the __newindex metamethod.",
    "label": "rawset",
    "type": "function",
    "detail": "(table, index, value)"
  },
  {
    "info": "Loads the given module. The function starts by looking into the package.loaded table to determine whether modname is already loaded.",
    "label": "require",
    "type": "function",
    "detail": "(modname)"
  },
  {
    "info": "If index is a number, returns all arguments after argument number index. Otherwise, index must be the string '#', and select returns the total number of extra arguments it received.",
    "label": "select",
    "type": "function",
    "detail": "(index, ...)"
  },
  {
    "info": "Sets the metatable for the given table. If metatable is nil, removes the metatable of the given table.",
    "label": "setmetatable",
    "type": "function",
    "detail": "(table, metatable)"
  },
  {
    "info": "Tries to convert its argument to a number. If the argument is already a number or a string convertible to a number, tonumber returns this number; otherwise, it returns nil.",
    "label": "tonumber",
    "type": "function",
    "detail": "(e [, base])"
  },
  {
    "info": "Receives a value of any type and converts it to a string in a human-readable format.",
    "label": "tostring",
    "type": "function",
    "detail": "(v)"
  },
  {
    "info": "Returns the type of its only argument, coded as a string.",
    "label": "type",
    "type": "function",
    "detail": "(v)"
  },
  {
    "info": "Returns the elements from the given list. This function is equivalent to return list[i], list[i+1], ···, list[j].",
    "label": "unpack",
    "type": "function",
    "detail": "(list [, i [, j]])"
  },
  {
    "info": "Creates a new Frame object from a captured frame.",
    "label": "Frame.new",
    "type": "function",
    "detail": "(frame)",
    "section": "Frame"
  },
  {
    "info": "Detects elements in the frame based on the specified options. Options include 'type' (text, image, or qr) and 'query'.",
    "label": "Frame:detect",
    "type": "function",
    "detail": "(options)",
    "section": "Frame"
  },
  {
    "info": "Draws the specified regions on the frame.",
    "label": "Frame:draw",
    "type": "function",
    "detail": "(regions)",
    "section": "Frame"
  },
  {
    "info": "Generates an AI-powered description of the frame, focusing on smart TV app content.",
    "label": "Frame:description",
    "type": "function",
    "detail": "()",
    "section": "Frame"
  },
  {
    "info": "Applies the given function to each element in the table and returns a new table with the results.",
    "label": "List.map",
    "type": "function",
    "detail": "(tbl, func)",
    "section": "List"
  },
  {
    "info": "Joins the elements of an array into a string, using the specified delimiter.",
    "label": "List.join",
    "type": "function",
    "detail": "(array, delimiter)",
    "section": "List"
  },
  {
    "info": "Finds the first element in the table that satisfies the given predicate function.",
    "label": "List.find",
    "type": "function",
    "detail": "(tbl, predicate)",
    "section": "List"
  },
  {
    "info": "Returns true if all elements in the list satisfy the given condition function.",
    "label": "List.all",
    "type": "function",
    "detail": "(list, conditionFn)",
    "section": "List"
  },
  {
    "info": "Creates a video stream iterator with the specified options.",
    "label": "stream",
    "type": "function",
    "detail": "(options)",
    "section": "Global"
  },
  {
    "info": "Creates a new Timer object.",
    "label": "Timer.new",
    "type": "function",
    "detail": "()",
    "section": "Timer"
  },
  {
    "info": "Starts the timer.",
    "label": "timer:start",
    "type": "function",
    "detail": "()",
    "section": "Timer"
  },
  {
    "info": "Stops the timer.",
    "label": "timer:stop",
    "type": "function",
    "detail": "()",
    "section": "Timer"
  },
  {
    "info": "Returns the elapsed time in milliseconds.",
    "label": "timer:elapsed",
    "type": "function",
    "detail": "()",
    "section": "Timer"
  },
  {
    "info": "Resets the timer to its initial state.",
    "label": "timer:reset",
    "type": "function",
    "detail": "()",
    "section": "Timer"
  },
  {
    "info": "Opens the specified app on the device.",
    "label": "open",
    "type": "function",
    "detail": "(name)",
    "section": "Global"
  },
  {
    "info": "Opens the specified app on the device.",
    "label": "openApp",
    "type": "function",
    "detail": "(name)",
    "section": "Global"
  },
  {
    "info": "Closes the specified app on the device.",
    "label": "closeApp",
    "type": "function",
    "detail": "(name)",
    "section": "Global"
  },
  {
    "info": "Applies default values to a table of parameters.",
    "label": "applyDefaults",
    "type": "function",
    "detail": "(params, defaults)",
    "section": "Global"
  },
  {
    "info": "Checks if the given value is truthy.",
    "label": "isTruthy",
    "type": "function",
    "detail": "(val)",
    "section": "Global"
  },
  {
    "info": "Generate lua code from the prompt.\n\nExample:\n\n  ```lua\n  local codegen = ai.codegen(\"Navigate home, wait 5 seconds, then press up and enter\")\n\n  print(codegen)\n  -- control.home() wait(5000) control.up() control.ok()\n  ```\n\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.codegen",
    "type": "function",
    "detail": "(prompt)",
    "section": ["ai"]
  },
  {
    "info": "\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.navigate",
    "type": "function",
    "detail": "(target, [opts = []])",
    "section": ["ai"]
  },
  {
    "info": "Navigate menus using AI\n\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.navigate",
    "type": "function",
    "detail": "(arg, target, opts)",
    "section": ["ai"]
  },
  {
    "info": "\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.prompt",
    "type": "function",
    "detail": "(user_prompt, [opts = []])",
    "section": ["ai"]
  },
  {
    "info": "Runs a prompt with a provided image, or the current screen and returns the response, and the viewpoint of the AI.\n\nExample:\n\n  ```lua\n  local response, viewpoint = ai.prompt(\"What is the color of the screen?\")\n\n  print(response)\n  -- \"The general color of the screen is blue.\"\n  ```\n\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.prompt",
    "type": "function",
    "detail": "(arg, prompt, opts)",
    "section": ["ai"]
  },
  {
    "info": "The same as `codegen`, but runs the generated code immediately.\n\nExample:\n\n  ```lua\n  ai.run(\"Navigate home, wait 5 seconds, then press up and enter\")\n  ```\n\n\nModule:\nProvides an API to interact with LLMs\n\n",
    "label": "ai.run",
    "type": "function",
    "detail": "(prompt, state)",
    "section": ["ai"]
  },
  {
    "info": "\n\nModule:\nProvides admin functions for privileged users TV Labs organization users\n\n",
    "label": "admin.send_to_protocol",
    "type": "function",
    "detail": "(protocol, cmd)",
    "section": ["admin"]
  },
  {
    "info": "Provides a way to import an image into a given session context. The image will be downloaded and encoded as a base64 string.\n\nExample:\n\n  ```lua\n  local my_image = asset.import(\"https://example.com/image.jpg\")\n  ```\n\n\nModule:\nProvides an API for importing assets, and saving screenshots / recordings.\n\n",
    "label": "asset.import",
    "type": "function",
    "detail": "(url)",
    "section": ["asset"]
  },
  {
    "info": "Upload an image or recording to the TV Labs cloud. The image will be uploaded to the TV Labs object store for the given organization, and a URL will be returned.\n\nExample:\n\n  ```lua\n  local my_image = screen.capture()\n  local stored_image = asset.upload(my_image)\n\n  print(stored_image)\n  -- [true, \"https://tvlabsassets.com/...\"]\n  ```\n\n\nModule:\nProvides an API for importing assets, and saving screenshots / recordings.\n\n",
    "label": "asset.upload",
    "type": "function",
    "detail": "(ref, [label = nil])",
    "section": ["asset"]
  },
  {
    "info": "Presses the `appAlexa` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appAlexa",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `appDisney` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appDisney",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `appFreevie` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appFreevie",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `appHulu` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appHulu",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `appNetflix` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appNetflix",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `appPrime` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.appPrime",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `back` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.back",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `chNext` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.chNext",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `chPrev` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.chPrev",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `down` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.down",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Enters the provided string of text via a given keyboard, or the system keyboard if one is not provided.\n\nExamples:\n\n```lua\n  control.enterText(\"Hello world!\")\n```\n\n```lua\n  local kb = keyboard.basic([[\n  e h l\n  n m o\n  ]], \"h\") -- Sets \"h\" as the initial key. Will set the top left key by default\n\n  control.enterText(kb, \"hello\")\n```\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.enterText",
    "type": "function",
    "detail": "(text)",
    "section": ["control"]
  },
  {
    "info": "\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.enterText",
    "type": "function",
    "detail": "(arg, text, [sleep = 100])",
    "section": ["control"]
  },
  {
    "info": "\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.enterTextAndSubmit",
    "type": "function",
    "detail": "(text, [submit_key = \"submit\"])",
    "section": ["control"]
  },
  {
    "info": "\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.enterTextAndSubmit",
    "type": "function",
    "detail": "(arg, text, submit_key, [sleep = 100])",
    "section": ["control"]
  },
  {
    "info": "Presses the `guide` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.guide",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `home` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.home",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `info` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.info",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `input` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.input",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `left` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.left",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `menu` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.menu",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `mute` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.mute",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num0` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num0",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num1` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num1",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num2` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num2",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num3` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num3",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num4` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num4",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num5` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num5",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num6` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num6",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num7` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num7",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num8` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num8",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `num9` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.num9",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `ok` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.ok",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `play` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.play",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `power` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.power",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `powerOff` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.powerOff",
    "type": "function",
    "detail": "()",
    "section": ["control"]
  },
  {
    "info": "Presses the `powerOn` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.powerOn",
    "type": "function",
    "detail": "()",
    "section": ["control"]
  },
  {
    "info": "Presses the `right` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.right",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Executes a sequence of key events provided as a string.\n\nOptions:\n  * `:delay` - The delay between key presses in milliseconds (default: 100)\n  * `:confirm` - Whether to press enter after the sequence (default: false)\n\nExamples:\n\n```lua\n  control.sequence(\"LLRR\")\n  control.sequence(\"UUDDLRLR\", delay: 200, confirm: true)\n```\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.sequence",
    "type": "function",
    "detail": "(key_sequence, [opts = []])",
    "section": ["control"]
  },
  {
    "info": "Presses the `settings` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.settings",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.tap",
    "type": "function",
    "detail": "(x, y)",
    "section": ["control"]
  },
  {
    "info": "Presses the `up` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.up",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `volumeDown` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.volumeDown",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "Presses the `volumeUp` button on the remote control.\n\n\nModule:\nHandles TV remote control.\n\n",
    "label": "control.volumeUp",
    "type": "function",
    "detail": "([n_times = 1, [delay = 100]])",
    "section": ["control"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.buildApp",
    "type": "function",
    "detail": "(app_id)",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.currentApp",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.info",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.killApp",
    "type": "function",
    "detail": "(app_id)",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.launchApp",
    "type": "function",
    "detail": "(app_id)",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.os",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.powerOff",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.powerOn",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.powercycle",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.standby",
    "type": "function",
    "detail": "()",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nHandles TV-related operations, such as rebooting, shutting down,\nand resetting to factory conditions.\n\n",
    "label": "device.uninstallApp",
    "type": "function",
    "detail": "(app_id)",
    "section": ["device"]
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".getDateTime",
    "type": "function",
    "detail": "()",
    "section": []
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".minutes",
    "type": "function",
    "detail": "(mins)",
    "section": []
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".print",
    "type": "function",
    "detail": "(args)",
    "section": []
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".print_error",
    "type": "function",
    "detail": "(args)",
    "section": []
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".seconds",
    "type": "function",
    "detail": "(secs)",
    "section": []
  },
  {
    "info": "\n\nModule:\nGlobal LUA functions\n\n",
    "label": ".warn",
    "type": "function",
    "detail": "(args)",
    "section": []
  },
  {
    "info": "Adds a modes layout to a keyboard\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.addMode",
    "type": "function",
    "detail": "(arg, mode, layout)",
    "section": ["keyboard"]
  },
  {
    "info": "Adds a transition between two modes\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.addModeTransition",
    "type": "function",
    "detail": "(arg, transition)",
    "section": ["keyboard"]
  },
  {
    "info": "Adds an arbitrary transition between two keys on a keyboard\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.addTransition",
    "type": "function",
    "detail": "(arg, from, to, with)",
    "section": ["keyboard"]
  },
  {
    "info": "Generate a basic single mode keyboard from a table. Creates a custom keyboard that does not have any modes (such as shift or caps lock). To create, pass a multi-line string where each line is a row of keys.\n\nExample:\n\n  ```lua\n  local kb = keyboard.basic([[\n  e h l\n  n m o\n  :::space:::\n  ]],\n  \"h\", -- Sets \"h\" as the initial key. Will set the top left key by default\n  \"left\") -- Sets ambiguity rule to select the leftmost key when navigating away from the space bar\n\n  control.enterText(kb, \"hello\")\n  ```\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.basic",
    "type": "function",
    "detail": "(table, [focus = nil, [ambiguity_rule = \"last_visited\"]])",
    "section": ["keyboard"]
  },
  {
    "info": "Creates an empty keyboard userdata object\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.createEmpty",
    "type": "function",
    "detail": "()",
    "section": ["keyboard"]
  },
  {
    "info": "Frees the keyboard graph in memory. Keyboards are automatically freed when the script ends.\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.destroy",
    "type": "function",
    "detail": "(arg)",
    "section": ["keyboard"]
  },
  {
    "info": "Sets the ambiguity rule of a keyboard\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.setAmbiguityRule",
    "type": "function",
    "detail": "(arg, ambiguity_rule)",
    "section": ["keyboard"]
  },
  {
    "info": "Sets the current focus of a keyboard\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.setFocus",
    "type": "function",
    "detail": "(arg, focus)",
    "section": ["keyboard"]
  },
  {
    "info": "Sets the current mode of a keyboard\n\n\nModule:\nAPI to select a system keyboad or define a custom keyboard built for your app.\n\n## Modeling a keyboard\n\nThe keyboard API is used to define the layout of the keyboard and the transitions between different modes of the keyboard.\n\nA mode is a layout represented by a multi-line string where each line is a row of keys. Rows do not need to be equal length. Each key is separated by a single space. Keys are strings of length 1 that represent what their input is, such as \"a\", \"b\", \"1\", etc.\nKeys can span multiple columns by using the `::key::` syntax. For example, a space key that spans 5 columns would be `:::::space:::::`. The trailing colons are optional, for example `:::::space` is equivalent.\nKeys can be `nil` or `null` to represent a non-navigable space. Other keys have special meaning, such as `space` which is transformed into `\" \"`.\n\nModes can be transitioned between by pressing a key. A transition is a tuple of values consisting of from_mode, to_mode and with_key.\nThis assumes that to transition the mode, the \"ok\" button is pressed on the `with_key`. An optional transition key may be specified if it is different.\n\nTo handle ambiguity when transitioning away from a spanning key, an ambiguity rule can be set. The default is `\"last_visited\"`, which is the behavior of most keyboards. Other valid values are \"left\" or \"right\".\n\nThe default focus of the keyboards will be the letter \"g\", but another key may be specified.\n\n## Usage\n\nThe keyboard API is designed to be used with the `control.enterText` function to simulate typing on a keyboard, however, an object oriented API is also provided.\n\n### Example\n\n```lua\nlocal kb = Keyboard.new()\n:addMode(\"lower\", [[\n  null  1 2 3 4 5 6 7 8 9 0 - = delete\n  tab  q w e r t y u i o p [ ]   caps  a s d f g h j k l ; ' submit\n  shift z x c v b n m , . / shift\n  ::::::::::::space::::::::::::\n]])\n:addMode(\"upper\", [[\n  null ! @ # $ % ^ & * ( ) _ + delete\n  tab  Q W E R T Y U I O P { }   caps  A S D F G H J K L : \" submit\n  shift Z X C V B N M < > ? shift\n  ::::::::::::space::::::::::::\n]])\n:addModeTransition(\"lower\", \"upper\", \"caps\")\n:addModeTransition(\"upper\", \"lower\", \"caps\")\n:setInitialFocus(\"g\")\n:setInitialMode(\"lower\")\n:setAmbiguityRule(\"last_visited\")\n\nKeyboard.enterText(kb, \"Hello world!\") -- enter text and stop\nKeyboard.enterTextAndSubmit(kb, \"Hello world!\", \"submit\") -- hit \"submit\" after typing\nKeyboard.addTransition(kb, \"q\", \"p\", \"green\") -- add an arbitrary transition between two keys, e.g. moves focus from q to p with the press of the \"green\" key\n```\n\n",
    "label": "keyboard.setMode",
    "type": "function",
    "detail": "(arg, mode)",
    "section": ["keyboard"]
  },
  {
    "info": "\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.alert",
    "type": "function",
    "detail": "(type, message)",
    "section": ["maintenance"]
  },
  {
    "info": "Calibrate the device.\n\nOnly TVs will be calibrated, other types of devices will be ignored.\n\nSee also `Sidecar.Calibration.calibrate/3`\n\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.calibrate",
    "type": "function",
    "detail": "()",
    "section": ["maintenance"]
  },
  {
    "info": "\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.detectGreenCamera",
    "type": "function",
    "detail": "(currentScreen)",
    "section": ["maintenance"]
  },
  {
    "info": "\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.pingDevice",
    "type": "function",
    "detail": "([opts = []])",
    "section": ["maintenance"]
  },
  {
    "info": "\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.setHealthy",
    "type": "function",
    "detail": "(service)",
    "section": ["maintenance"]
  },
  {
    "info": "\n\nModule:\nProvides maintenance functions for privileged users\n\n",
    "label": "maintenance.setUnhealthy",
    "type": "function",
    "detail": "(service)",
    "section": ["maintenance"]
  },
  {
    "info": "\n\nModule:\nNavigation macros. These should return a boolean if they succeed.\nIf not possible to ascertain they should print a warning\n\n",
    "label": "navigateTo.app",
    "type": "function",
    "detail": "(index)",
    "section": ["navigateTo"]
  },
  {
    "info": "\n\nModule:\nNavigation macros. These should return a boolean if they succeed.\nIf not possible to ascertain they should print a warning\n\n",
    "label": "navigateTo.home",
    "type": "function",
    "detail": "()",
    "section": ["navigateTo"]
  },
  {
    "info": "\n\nModule:\nNavigation macros. These should return a boolean if they succeed.\nIf not possible to ascertain they should print a warning\n\n",
    "label": "navigateTo.home",
    "type": "function",
    "detail": "(homeText, [presses = 1, [timeout = 5000]])",
    "section": ["navigateTo"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.disableRateLimit",
    "type": "function",
    "detail": "([opts = []])",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.enableRateLimit",
    "type": "function",
    "detail": "(limit_down_mbit)",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.enableRateLimit",
    "type": "function",
    "detail": "(limit_down_mbit, limit_up_mbit)",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.enableRateLimit",
    "type": "function",
    "detail": "(limit_down_mbit, limit_up_mbit, opts)",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.isRateLimitActive",
    "type": "function",
    "detail": "()",
    "section": ["network"]
  },
  {
    "info": "Makes an HTTP request and returns the response.\n\nOptions:\n- method: HTTP method (e.g., \"GET\", \"POST\", \"PUT\", \"DELETE\")\n- headers: A table of HTTP headers\n- body: The request body (for POST, PUT, etc.). Maximum size is 10 MB.\n- auth: Authentication method and credentials\n- params: Query parameters\n- timeout: Request timeout in milliseconds\n\nReturns a table with:\n- status: HTTP status code\n- body: Response body (decoded)\n- error: Error message (if any)\n\nExample:\n  ```lua\n  local response = network.request(\"https://api.example.com/data\", {\n    method = \"GET\",\n    headers = {[\"Content-Type\"] = \"application/json\"},\n    auth = {type = \"bearer\", token = \"my-token\"},\n    params = {limit = 10, offset = 0}\n  })\n  ```\nOnly supports json at the moment\n\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.request",
    "type": "function",
    "detail": "(url, [opts = []])",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "network.stats",
    "type": "function",
    "detail": "()",
    "section": ["network"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.do_measure",
    "type": "function",
    "detail": "(qoe_data, timeout, distance, threshold, max_consecutive_mismatches)",
    "section": ["qoe"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.do_record",
    "type": "function",
    "detail": "(duration, timeout, starting_frame, distance, threshold)",
    "section": ["qoe"]
  },
  {
    "info": "\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.get_frame_feature",
    "type": "function",
    "detail": "(starting_frame)",
    "section": ["qoe"]
  },
  {
    "info": "Measure the QoE of a video stream with the given QoE ID.\n\n## Positional Parameters\n- `qoe_id`: The QoE ID corresponds to the QoE recording session.\n\n## Keyword Parameters\n- `timeout`: The maximum time to wait for the QoE measuring task to finish.\n\n- `threshold`: The threshold for the distance between the feature vectors of the frames.\n\n  Defaults to 4.\n\n- `distance`: The distance metric to use for comparing the feature vectors of the frames.\n\n  The default distance metric is `\"euclidean\"`.\n\n- `maxConsecutiveMismatches`: The maximum number of consecutive mismatches allowed.\n\n  Defaults to 10.\n\n## Returns\n- `true`: If any playback issues have been detected.\n- `false`: If no playback issues have been detected.\n\n## Raises\n- Runtime exeception will be raised if the QoE ID cannot be found.\n\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.measure",
    "type": "function",
    "detail": "(qoe_id, [opts = []])",
    "section": ["qoe"]
  },
  {
    "info": "Persist the QoE data with the given QoE ID.\n\n## Positional Parameters\n- `qoe_id`: The QoE ID corresponds to the QoE recording session.\n\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.persist",
    "type": "function",
    "detail": "(qoe_id)",
    "section": ["qoe"]
  },
  {
    "info": "Record a video stream for QoE analysis.\n\n## Parameters\n- `duration`: The duration of the video stream to record, counting from the starting frame.\n\n## Options\n- `timeout`: The maximum time to wait for the starting frame to appear in the video stream.\n\n- `startingFrame`: The starting frame of the video stream.\n\n  The recording starts when it detects the same frame in the video stream.\n\n- `threshold`: The threshold for the distance between the feature vectors of the frames.\n\n  Defaults to 4.\n\n- `distance`: The distance metric to use for comparing the feature vectors of the frames.\n\n  The default distance metric is `\"euclidean\"`.\n\n## Returns\n- `qoe_id`: An QoE ID corresponds to this QoE recording session and can be used to measure the QoE.\n\n\nModule:\nHandles Networking related operations.\n\n",
    "label": "qoe.record",
    "type": "function",
    "detail": "(duration, [opts = []])",
    "section": ["qoe"]
  },
  {
    "info": "\n\nModule:\nProvides an API for querying the state of a region.\n\n",
    "label": "region.active?",
    "type": "function",
    "detail": "(region_name)",
    "section": ["region"]
  },
  {
    "info": "\n\nModule:\nProvides an API for querying the state of a region.\n\n",
    "label": "region.find_region",
    "type": "function",
    "detail": "(region_id)",
    "section": ["region"]
  },
  {
    "info": "\n\nModule:\nProvides an API for querying the state of a region.\n\n",
    "label": "region.find_region",
    "type": "function",
    "detail": "(ui, region)",
    "section": ["region"]
  },
  {
    "info": "Check if a region is active, i.e., if it matches the intended content on the screen.\n\n\nModule:\nProvides an API for querying the state of a region.\n\n",
    "label": "region.is_active",
    "type": "function",
    "detail": "(region)",
    "section": ["region"]
  },
  {
    "info": "Captures current frame and returns userdata object\n\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.capture",
    "type": "function",
    "detail": "()",
    "section": ["screen"]
  },
  {
    "info": "\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.capture",
    "type": "function",
    "detail": "(region)",
    "section": ["screen"]
  },
  {
    "info": "Get's a UI element by name\n\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.get",
    "type": "function",
    "detail": "(name)",
    "section": ["screen"]
  },
  {
    "info": "\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.is",
    "type": "function",
    "detail": "(screen_name)",
    "section": ["screen"]
  },
  {
    "info": "\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.press",
    "type": "function",
    "detail": "(name)",
    "section": ["screen"]
  },
  {
    "info": "\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.print",
    "type": "function",
    "detail": "(text)",
    "section": ["screen"]
  },
  {
    "info": "\n\nModule:\nProvides an API for capturing screnshots and performing screen recordings\n\n",
    "label": "screen.type",
    "type": "function",
    "detail": "()",
    "section": ["screen"]
  },
  {
    "info": "Binary search for an ordered series of images.\nIf the `test_func` returns `true`, the search will continue to the left (earlier in the list),\nand if it returns `false`, the search will continue to the right (later in the list).\n\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.binary_search",
    "type": "function",
    "detail": "(images, test_func)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.brightness",
    "type": "function",
    "detail": "()",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.brightness",
    "type": "function",
    "detail": "(arg)",
    "section": ["vision"]
  },
  {
    "info": "In general, a hamming distance of less than 10 indicates that the images are\nvery similar. A distance of less than 20 suggests the images are quite similar.\nAny other distance suggests the images have little in common.\n\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.compare",
    "type": "function",
    "detail": "(arg)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.compare",
    "type": "function",
    "detail": "(arg1, arg2)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.containsText",
    "type": "function",
    "detail": "(search_term)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.containsText",
    "type": "function",
    "detail": "(arg, search_term)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.draw",
    "type": "function",
    "detail": "(arg, regions)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.readText",
    "type": "function",
    "detail": "()",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.readText",
    "type": "function",
    "detail": "(arg)",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides an API for automating vision-related tasks like\ndetecting screen changes, reading on-screen text, etc.\n\n",
    "label": "vision.waitForText",
    "type": "function",
    "detail": "(search_term, [timeout_ms = 3000])",
    "section": ["vision"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.begin_step",
    "type": "function",
    "detail": "(step_id, step_type)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.end_step",
    "type": "function",
    "detail": "(step_id, step_data)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.fail_step",
    "type": "function",
    "detail": "(step_id, reason, step_data)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.log_error",
    "type": "function",
    "detail": "(step_id, error_message)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.log_input",
    "type": "function",
    "detail": "(step_id, key, value)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.log_output",
    "type": "function",
    "detail": "(step_id, key, value)",
    "section": ["workflow"]
  },
  {
    "info": "\n\nModule:\nProvides workflow instrumentation functions for Lua scripts.\n\n",
    "label": "workflow.set_progress",
    "type": "function",
    "detail": "(step_id, progress)",
    "section": ["workflow"]
  }
]
